import { EditorProps, EditorView } from 'prosemirror-view'
import { AriaAttributes, HTMLAttributes } from 'react'
import { Plugin } from 'prosemirror-state'
import { Schema } from 'prosemirror-model'

export type ProseInputMention = UserMention | ArticleMention

export interface ProseInputProps extends Pick<HTMLAttributes<AriaAttributes>, 'role' | 'aria-label'> {
  className?: string
  initialHtmlString?: string
  onChange?: (htmlString: string, plainTextString: string, mentions: ProseInputMention[], pills?: string[]) => void
  onFocus?: (e: FocusEvent) => void
  onBlur?: (e: FocusEvent) => void
  placeholder?: string
  overrideMentionPromptClassname?: string
  handleKeyDown?: EditorProps['handleKeyDown']
  isDisabled?: boolean
  withBorder?: boolean
  autoFocus?: boolean
  plugins?: {
    mentions?: Plugin<any, any>
    other?: Plugin<any, any>[]
  }
  schema?: Schema
}

export enum MentionType {
  User = 'User',
  Article = 'Article',
  Snippet = 'Snippet',
}

type UserMention = {
  id: number
  title: string
  type: MentionType.User
}

type ArticleMention = {
  id: string
  title: string
  type: MentionType.Article
}

export type ProseInputHandle = {
  view: () => EditorView<any> | null
  focus: () => void
  blur: () => void
  clear: () => void
  replaceHTMLString: (htmlString: string) => void
}
